<template>
  <div id="contenedor">
    <v-layout row wrap="">
      <v-flex xs12 sm12 md12>
        <v-card class="table" elevation="4">
          <v-toolbar flat elevation="4">
            <v-card class="icon">
                <v-icon style="margin-left:30px; margin-top:25px" color="white" x-large="">mdi-collage</v-icon>
            </v-card>
            <div class="usuario">AREAS</div>
              <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="700px" persistent>
              <template v-slot:activator="{ on }">
                <v-btn dark class="botonplus" v-on="on"><v-icon color="white">mdi-plus-thick</v-icon></v-btn>
              </template>
                <v-card style="display: flex; flex-direction: column; max-height: 90vh;">
                  <v-card-title class="nav" style="flex-shrink: 0;">
                      <span class="headline" style="color:whitesmoke"><v-icon color="white">mdi-collage</v-icon> {{ formTitle }}</span>
                  </v-card-title>
                  <!-- componente del modal para agregar y actualizar -->
                  <v-card-text style="flex: 1 1 auto; overflow-y: auto; min-height: 0;">
                    <v-container grid-list-md>
                      <v-layout wrap>
                          <v-flex xs12 sm12 md12>
                            <v-text-field v-model="editedItem.areas" label="Nombre Area"></v-text-field>
                          </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <!-- botones para cancelar y agregregar y validacion de campos vacios -->
                  <v-card-actions style="flex-shrink: 0;">
                    <v-spacer></v-spacer>
                      <v-btn color="#1D3C7F"  dark @click="close">Cancelar</v-btn>
                      <v-btn
                      color="#1D3C7F"
                      dark
                      @click="save"
                      :disabled="!editedItem.areas"
                      >Guardar</v-btn>
                  </v-card-actions>
                  <!-- <pre>{{editedItem}}</pre>  -->
                </v-card>
            </v-dialog>
          </v-toolbar> 
          <br>
          <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar Area"
          single-line
          class="text-field"
          color="#111c3d"
          ></v-text-field>
          <br>
          <v-data-table 
          :headers="headers" 
          :items="areas" 
          :search="search"
          style=" border: 2px solid #111c3d;"
          class="elevation-3"
          >
          <!-- tabla donde se pintan los datos obtenidos del arreglo -->
          <template v-slot:item.action="{ item }">
            <v-icon
            small
            class="mr-2"
            @click="editItem(item)"
            >
            mdi-pencil
            </v-icon>
          </template>
          <template v-slot:no-data>
            <v-alert :value="true" color="#111c3d" icon="mdi-alert" outlined>No se encontro su busqueda</v-alert>
          </template>
          </v-data-table>
          <!-- alertas de las acciones que se hacen -->
          <v-snackbar
          v-model="snackbar"
          :bottom="y === 'bottom'"
          :left="x === 'left'"
          :multi-line="mode === 'multi-line'"
          :right="x === 'right'"
          :timeout="timeout"
          :top="y === 'top'"
          :vertical="mode === 'vertical'"
          color="#3945d0"
          style="color:white"
          >
          {{ text }}
          <v-btn color="#3945d0" depressed @click="snackbar = false">Cerrar</v-btn>
          </v-snackbar>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";
import env from "../env";
export default {
  data() {
    return {
      show: false,
      snackbar: false,
      y: "top",
      x: null,
      /* fechaN:false,
      fechaI:false, */
      mode: "",
      timeout: 6000,
      text: "",
      search: "",
      areas: [],
      dialog: false,
      headers: [
        {
          text: "Id",
          align: "left",
          value: "idArea",
          align: "center",
          class: "column"
        },
        {
          text: "Area",
          value: "areas",
          align: "center",
          class: "column"
        },
        {
          text: "Acciones",
          value: "action",
          sortable: false,
          align: "center",
          class: "column"
        },
      ],
      defaultItem: {
        idArea: "",
        areas: "",
        riesgo: 0
      },
      editedIndex: -1,
      editedItem: {
        idArea: "",
        areas: "",
        riesgo: 0
      }
    };
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nueva Area" : "Editar Area";
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  mounted() {
    this.obtenerAreas();
  },

  methods: {

  // Metodo para obtener los areas
    obtenerAreas() {
      axios.get(`${env.endpoint}user/areastodos`).then(res => (this.areas = res.data));
    },

  /**
   * Metodo para agregar fila de la tabla en la modal
   */
    editItem(item) {
      this.editedIndex = this.areas.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

  /**
   * Metodo para cerrar la modal
   */
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

  /**
   * Metodo para guardar y actualizar
   */
    save() {
      // JSON con forma de la tabla cc_areas
      const payload = {
        cc_id_area: this.editedIndex > -1 ? this.editedItem.idArea : null,
        cc_nombre_area: this.editedItem.areas,
        riesgo: this.editedItem.riesgo || 0
      };

      const areaJson = encodeURIComponent(JSON.stringify(payload));

      if (this.editedIndex > -1) {
        // ACTUALIZAR
        axios
          .get(`${env.endpoint}user/modificar_areas?area=${areaJson}`)
          .then(res => {
            if (res.data.mensaje === "area actualizada") {
              this.snackbar = true;
              this.text = "Área actualizada satisfactoriamente";
            } else {
              this.snackbar = true;
              this.text = "Error en la actualización de área";
            }
            this.obtenerAreas();
          });
      } else {
        // CREAR
        axios
          .get(`${env.endpoint}user/create_app?app=${areaJson}`)
          .then(res => {
            if (res.data.mensaje === "area registrada") {
              this.snackbar = true;
              this.text = "Área registrada satisfactoriamente";
            } else if (res.data.mensaje === "error app existe") {
              this.snackbar = true;
              this.text = "El área ya existe en la plataforma";
            } else {
              this.snackbar = true;
              this.text = "Error al registrar área";
            }
            this.obtenerAreas();
          });
      }

      this.close();
    }
  }
};
</script>